import { useState, useEffect } from "react";
import { GOLFERS } from "./golfer_data";

const LEADERBOARD_URL = process.env.NODE_ENV === 'development'
  ? '/masters2026/leaderboard.json'
  : 'https://walkingfishes.com/leaderboard.json';
const POLL_INTERVAL = 1 * 60 * 1000; // 15 minutes

export function useLeaderboard() {
  const [golfers, setGolfers] = useState(
    GOLFERS.map((g) => ({
      name: g.name,
      position: null,
      posQualifier: "",
      toPar: null,
      thru: null,
      round1: null,
      round2: null,
      round3: null,
      round4: null,
      winnings: 0,
      status: null,
    }))
  );
  const [lastUpdated, setLastUpdated] = useState(null);
  const [currentRound, setCurrentRound] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      // console.log("Fetching leaderboard...");
      try {
        const res = await fetch(LEADERBOARD_URL);
        // console.log("Response status:", res.status);
        let data;
        try {
          data = await res.json();
        } catch (parseErr) {
          // console.log("Parse error:", parseErr.message);
          return;
        }
        // Build a lookup map from the API: "First Last" -> player object
        const apiMap = {};
        for (const player of data.leaderboard) {
          apiMap[player.name] = player;
        }

        // Merge live data into your roster
        const updated = GOLFERS.map((g) => {
          const live = apiMap[g.name];
          if (!live) {
            return { ...g, status: "unknown" };
          }

          // Figure out position qualifier (T for tied)
          const tied = data.leaderboard.filter(
            (p) => p.position === live.position && p.status !== "cut" && p.status !== "wd" && p.status !== "dsq"
          ).length > 1;

          return {
            name: g.name,
            position: live.status === "cut" ? "CUT" : live.position,
            posQualifier: tied ? "T" : "",
            toPar: live.totalToPar,
            thru: live.thru === 18 ? "F" : live.thru,
            round1: live.round1 ?? "",
            round2: live.round2 ?? "",
            round3: live.round3 ?? "",
            round4: live.round4 ?? "",
            winnings: live.earnings ? parseFloat(live.earnings) : 0,
            status: live.status,
          };
        });

        setGolfers(updated);
        setLastUpdated(data.lastUpdated);
        setCurrentRound(data.currentRound);
        setError(null);
      } catch (err) {
        setError("Unable to load leaderboard data.");
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
    const interval = setInterval(fetchLeaderboard, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return { golfers, lastUpdated, currentRound, loading, error };
}